import React, { Component, Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";

// --- MUDANÇA 1: Importar `lazy` e `Suspense` do React ---

// Componente da página inicial é carregado normalmente para ser mais rápido
import HomeV1 from './components/home-v1';

// --- MUDANÇA 2: Usar `React.lazy` para carregar outras páginas sob demanda ---
const HomeV2 = lazy(() => import('./components/home-v2'));
const HomeV3 = lazy(() => import('./components/home-v3'));
const AboutUs = lazy(() => import('./components/about'));
const TourList = lazy(() => import('./components/tour-list'));
const TourListEuro = lazy(() => import('./components/tour-list-euro'));
const TourListOutros = lazy(() => import('./components/tour-list-outros'));
const TourListNorte = lazy(() => import('./components/tour-list-norte'));
const TourListV2 = lazy(() => import('./components/tour-list-v2'));
const TourListV3 = lazy(() => import('./components/tour-list-v3'));
const TourDetails = lazy(() => import('./components/tour-details'));
const DestinationLIst = lazy(() => import('./components/destination-list'));
const DestinationLIstV2 = lazy(() => import('./components/destination-list-v2'));
const DestinationDetails = lazy(() => import('./components/destination-details'));
const Gallery = lazy(() => import('./components/gallery'));
const GalleryDetails = lazy(() => import('./components/gallery-details'));
const Faq = lazy(() => import('./components/faq'));
const Contact = lazy(() => import('./components/contact'));
const Booking = lazy(() => import('./components/booking'));
const WhatsApp = lazy(() => import('./components/whatsApp'));
const Error = lazy(() => import('./components/error'));
const CommingSoon = lazy(() => import('./components/comming-soon'));
const UserProfile = lazy(() => import('./components/user-profile'));
const Blog = lazy(() => import('./components/blog'));
const BlogV2 = lazy(() => import('./components/blog-v2'));
const BlogV3 = lazy(() => import('./components/blog-v3'));
const BlogDetails = lazy(() => import('./components/blog-details'));
const BlogDetailsBrazil = lazy(() => import('./components/blog-details-brazil')); 
const BlogDetailsUSAPage = lazy(() => import('./components/blog-details-usa')); 
const BlogDetailsIcelandPage = lazy(() => import('./components/blog-details-iceland')); 
const BlogDetailsEuropeCapitalsPage = lazy(() => import('./components/blog-details-euro')); 
const BlogDetailsGrandCanyonPage = lazy(() => import('./components/blog-details-grand'));
const BlogDetailsAsiaPage = lazy(() => import('./components/blog-details-asia'));
const BlogDetailsParisPage = lazy(() => import('./components/blog-details-paris'));
const BlogDetailsCastlesPage = lazy(() => import('./components/blog-details-castle'));

// --- MUDANÇA 3: Criar um componente de "Carregando..." para o Suspense ---
const LoadingFallback = () => (
    <div style={{ textAlign: 'center', padding: '50px' }}>
        Carregando página...
    </div>
);

class Root extends Component {
    render() {
        return(
            <HashRouter basename="/">
                <div>
                    {/* --- MUDANÇA 4: Envolver o Switch com o Suspense --- */}
                    <Suspense fallback={<LoadingFallback />}>
                        <Switch>
                            <Route exact path="/" component={HomeV1} />
                            <Route path="/home-v2" component={HomeV2} />
                            <Route path="/home-v3" component={HomeV3} />
                            <Route path="/about" component={AboutUs} />
                            <Route path="/tour-list" component={TourList} />
                            <Route path="/tour-list-euro" component={TourListEuro} />
                            <Route path="/tour-list-outros" component={TourListOutros} />
                            <Route path="/tour-list-norte" component={TourListNorte} />
                            <Route path="/tour-list-v2" component={TourListV2} />
                            <Route path="/tour-list-v3" component={TourListV3} />
                            <Route path="/tour-details" component={TourDetails} />
                            <Route path="/destination-list" component={DestinationLIst} />
                            <Route path="/destination-list-v2" component={DestinationLIstV2} />
                            <Route path="/destination-details" component={DestinationDetails} />
                            <Route path="/gallery" component={Gallery} />
                            <Route path="/gallery-details" component={GalleryDetails} />
                            <Route path="/faq" component={Faq} />
                            <Route path="/contact" component={Contact} />
                            <Route path="/booking" component={Booking} />
                            <Route path="/whatsApp" component={WhatsApp} />
                            <Route path="/error" component={Error} />
                            <Route path="/comming-soon" component={CommingSoon} />
                            <Route path="/user-profile" component={UserProfile} />
                            <Route path="/blog" component={Blog} />
                            <Route path="/blog-v2" component={BlogV2} />
                            <Route path="/blog-v3" component={BlogV3} />
                            <Route path="/blog-details" component={BlogDetails} />
                            <Route path="/blog-details-brazil" component={BlogDetailsBrazil} /> 
                            <Route path="/blog-details-usa" component={BlogDetailsUSAPage} />
                            <Route path="/blog-details-iceland" component={BlogDetailsIcelandPage} />
                            <Route path="/blog-details-euro" component={BlogDetailsEuropeCapitalsPage} />
                            <Route path="/blog-details-grand" component={BlogDetailsGrandCanyonPage} />
                            <Route path="/blog-details-asia" component={BlogDetailsAsiaPage} />
                            <Route path="/blog-details-paris" component={BlogDetailsParisPage} />
                            <Route path="/blog-details-castle" component={BlogDetailsCastlesPage} />
                        </Switch>
                    </Suspense>
                </div>
            </HashRouter>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('viaje'));
